import { Injectable } from '@angular/core';
import { CONTROLLERS, ENDPOINTS } from 'src/app/constants';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { ProcessorDetails, Response } from 'src/app/models';

@Injectable({
  providedIn: 'root'
})
export class ProcessorService {

  private api: string = CONTROLLERS.PAYMENTS.PROCESSOR;
  constructor(private apiService: ApiService) { }

  getAllProcessors(): Observable<Response<ProcessorDetails[]>> {
    return this.apiService.get(`${this.api}/${ENDPOINTS.PAYMENTS.PROCESSOR.GET_ALL_PROCESSOR}`);
  }

  getById(processorId: number): Observable<Response<ProcessorDetails>> {
    return this.apiService.getById(
      processorId.toString(),
      `${this.api}/${ENDPOINTS.PAYMENTS.PROCESSOR.GET_PROCESSOR_BY_ID}`
    );
  }

  createProcessor(
    updateReqCommand: ProcessorDetails
  ): Observable<Response<boolean>> {
    return this.apiService.put(
      '',
      `${this.api}/${ENDPOINTS.PAYMENTS.PROCESSOR.CRAETE_PROCESSOR}`,
      updateReqCommand
    );
  }

  updateProcessor(
    updateReqCommand: ProcessorDetails
  ): Observable<Response<boolean>> {
    return this.apiService.put(
      '',
      `${this.api}/${ENDPOINTS.PAYMENTS.PROCESSOR.UPDATE_PROCESSOR}`,
      updateReqCommand
    );
  }
}
